<template>
  <el-card class="page-card">
    <div slot="header" class="page-header">
      <div class="page-hedaer">
        <h4 class="page-title">我的订单</h4>
        <span class="title-info">(返利订单列表与佣金信息)</span>
      </div>
      <order-claim @confirm="handleReset"></order-claim>
    </div>

    <!-- 搜索筛选区域 -->
    <div class="search-bar">
      <el-input
        v-model="searchForm.keyword"
        placeholder="搜索订单号/商品名称/店铺"
        clearable
        class="search-input"
        @keyup.enter.native="handleSearch"
        size="small"
      ></el-input>
      <el-select
        v-model="searchForm.status"
        placeholder="跟单状态"
        clearable
        size="small"
        class="search-select"
      >
        <el-option label="查询中" value="1"></el-option>
        <el-option label="已跟单" value="2"></el-option>
        <el-option label="已丢单" value="3"></el-option>
      </el-select>
      <el-select
        v-model="searchForm.flow_point"
        placeholder="订单状态"
        clearable
        size="small"
        class="search-select"
      >
        <el-option label="已支付" value="PAY_SUCC"></el-option>
        <el-option label="已收货" value="CONFIRM,SETTLE"></el-option>
        <el-option label="已退款" value="REFUND"></el-option>
      </el-select>
      <el-date-picker
        v-model="searchForm.dateRange"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        value-format="yyyy-MM-dd"
        size="small"
        class="date-picker"
      ></el-date-picker>
      <el-button
        size="small"
        type="primary"
        icon="el-icon-search"
        @click="handleSearch"
        >搜索</el-button
      >
      <el-button size="small" icon="el-icon-refresh" @click="handleReset"
        >重置</el-button
      >
    </div>
    <!-- <div style="display: flex; align-items: center">
      <div class="stat-item">
        <div class="stat-label">今日佣金:</div>
        <div class="stat-value">¥220.00</div>
      </div>
      <div class="stat-item" style="margin-right:0">
        <div class="stat-label">今日有效订单:</div>
        <div class="stat-value">2</div>
        <div class="stat-label">单</div>
      </div>
      <span class="line"></span>
      <div class="stat-item">
        <div class="stat-label">昨日佣金:</div>
        <div class="stat-value">¥220.00</div>
      </div>
      <div class="stat-item" style="margin-right:0">
        <div class="stat-label">昨日有效订单:</div>
        <div class="stat-value">2</div>
        <div class="stat-label">单</div>
      </div>
      <span class="line"></span>
      <div class="stat-item">
        <div class="stat-label">近7日佣金:</div>
        <div class="stat-value">¥220.00</div>
      </div>
      <div class="stat-item">
        <div class="stat-label">本月佣金:</div>
        <div class="stat-value">¥220.00</div>
      </div>
      <div class="stat-item">
        <div class="stat-label">上月佣金:</div>
        <div class="stat-value">¥220.00</div>
      </div>
    </div> -->

    <el-table :data="orders" v-loading="loading">
      <div slot="empty">
        <el-empty description="暂无订单数据"></el-empty>
      </div>
      <el-table-column prop="id" label="订单号" width="300">
        <template slot-scope="{ row }">
          <div>订单编号：{{ row.id }}</div>
          <div>报单时间：{{ row.created_at }}</div>
          <div v-if="row.order">收货时间：{{ row.order.confirm_time }}</div>
          <div>
            跟单状态：
            <el-tag size="small" :type="getStatusType(row.bind_status)">
              {{ getStatusText(row.bind_status) }}
            </el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="商品信息" min-width="500">
        <template slot-scope="{ row }">
          <div v-if="row.order" class="goods-info">
            <el-image
              :src="row.order.item_img"
              class="goods-image"
              fit="cover"
            ></el-image>
            <div class="goods-title">
              <div class="title">{{ row.order.item_title }}</div>
              <div style="font-size: 12px">
                订单状态：<el-tag
                  size="small"
                  :type="getOrderStatusType(row.order.flow_point)"
                >
                  {{ getOrderStatusText(row.order.flow_point) }}
                </el-tag>
              </div>
              <div style="font-size: 12px">
                支付金额：
                <span style="color: #f56c6c">¥{{ row.order.pay_price }}</span>
              </div>
              <span class="shop-name">店铺：{{ row.order.shop_name }}</span>
            </div>
          </div>
          <div v-else class="goods-info">
            <el-image class="goods-image" fit="cover">
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i></div
            ></el-image>
            <div class="goods-title" style="display: flex; align-items: center">
              <div
                v-if="
                  (Date.now() -new Date(row.created_at)) > 1000 * 60 * 20 ||
                  row.bind_status == 3
                "
                class="text-danger"
              >
                建议退单重拍
              </div>
              <div v-else class="text-success">跟单中，请耐心等待</div>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="预估佣金">
        <template slot-scope="scope">
          <span class="text-danger"
            >¥{{ (scope.row.self_commission / 100).toFixed(2) }}</span
          >
        </template>
      </el-table-column>
      <el-table-column prop="settle_status" label="结算状态" width="120">
        <template slot-scope="scope">
          <el-tag
            v-if="scope.row.bind_status != 1"
            :type="getSettleType(scope.row)"
          >
            {{ getSettleText(scope.row) }}
          </el-tag>
          <div v-else>--</div>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="created_at" label="报单时间"> </el-table-column> -->
    </el-table>

    <el-pagination
      v-if="total > 0"
      style="margin-top: 20px; text-align: right"
      :current-page="page"
      :page-size="pageSize"
      :total="total"
      layout="total, prev, pager, next"
      @current-change="fetchOrders"
    ></el-pagination>
  </el-card>
</template>

<script>
import api from "@/api";
import OrderClaim from "@/components/OrderClaim.vue";

export default {
  name: "Orders",
  components: {
    OrderClaim,
  },
  data() {
    return {
      orders: [],
      loading: false,
      page: 1,
      pageSize: 10,
      total: 0,
      searchForm: {
        keyword: "",
        status: "",
        flow_point: "",
        dateRange: [],
      },
    };
  },
  mounted() {
    this.fetchOrders(1);
  },
  methods: {
    async fetchOrders(page) {
      this.loading = true;
      try {
        const params = {
          page,
          page_size: this.pageSize,
        };
        // 添加筛选参数
        if (this.searchForm.keyword) {
          params.keyword = this.searchForm.keyword;
        }
        if (this.searchForm.status) {
          params.status = this.searchForm.status;
        }
        if (this.searchForm.flow_point) {
          params.flow_point = this.searchForm.flow_point;
        }
        if (
          this.searchForm.dateRange &&
          this.searchForm.dateRange.length === 2
        ) {
          params.start_date = this.searchForm.dateRange[0];
          params.end_date = this.searchForm.dateRange[1];
        }
        const res = await api.get("/api/orders", { params });
        this.orders = res.data.items;
        this.total = res.data.total;
        this.page = page;
      } catch (e) {
        this.$message.error(e.userMessage || "获取订单失败");
      } finally {
        this.loading = false;
      }
    },
    handleSearch() {
      this.fetchOrders(1);
    },
    handleReset() {
      this.searchForm = {
        keyword: "",
        status: "",
        dateRange: [],
      };
      this.fetchOrders(1);
    },
    getSettleType(data) {
      if (
        (data.settle_status == 1 || data.settle_status == 2) &&
        !data.is_commission_settled
      ) {
        return "primary";
      } else if (data.is_commission_settled) {
        return "success";
      } else if (data.settle_status == 3) {
        return "danger";
      } else {
        return "danger";
      }
    },
    getSettleText(data) {
      if (
        (data.settle_status == 1 ||
        data.settle_status == 2) && !data.is_commission_settled
      ) {
        return "待结算";
      } else if (data.is_commission_settled) {
        return "已结算";
      } else if (data.settle_status == 3) {
        return "不结算";
      } else {
        return "未知";
      }
    },
    getStatusType(status) {
      const statusMap = {
        1: "primary",
        2: "success",
        3: "danger",
      };
      return statusMap[status] || "primary";
    },
    getStatusText(status) {
      const textMap = {
        1: "查询中",
        2: "已跟单",
        3: "已丢单",
      };
      return textMap[status] || status || "未知";
    },
    getOrderStatusType(status) {
      const statusMap = {
        PAY_SUCC: "success",
        CONFIRM: "success",
        SETTLE: "success",
        REFUND: "danger",
      };
      return statusMap[status] || "primary";
    },
    getOrderStatusText(status) {
      const textMap = {
        PAY_SUCC: "已支付",
        CONFIRM: "已收货",
        SETTLE: "已收货",
        REFUND: "已退款",
      };
      return textMap[status] || status || "未知";
    },
  },
};
</script>

<style scoped>
.line {
  height: 14px;
  width: 1px;
  background-color: #909399;
  margin: 0 20px;
}
.stat-item {
  text-align: center;
  display: flex;
  margin-right: 10px;
}

.stat-label {
  font-size: 13px;
  color: #909399;
}

.stat-value {
  font-size: 13px;
  /* font-weight: bold; */
  color: #409eff;
}
.page-hedaer {
  display: flex;
  align-items: center;
}
.page-title {
  margin: 0;
}
.goods-image >>> .image-slot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: #f5f7fa;
  color: #909399;
  font-size: 18px;
}
.title-info {
  margin-left: 5px;
  font-size: 12px;
  color: #909399;
}
.text-gray {
  color: #999;
}
.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.text-danger {
  color: #f56c6c;
}
.text-success {
  color: #67c23a;
}
.goods-image {
  width: 90px;
  height: 90px;
  flex-shrink: 0;
}
.goods-info {
  display: flex;
  align-items: stretch;
}
.goods-title {
  padding: 0 10px;
}
.goods-title .title {
  height: 26px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.goods-title .shop-name {
  display: block;
  color: #909399;
}
.search-bar {
  margin-bottom: 10px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  display: flex;
  align-items: center;
}
.search-input {
  width: 220px;
}
.search-select {
  width: 140px;
}
.date-picker {
  width: 260px;
}
</style>
